<template>
  <div>
    <div class="popup__content">
      <div class="text-size-l text-bold text-color mb24">Куда восстановить правило?</div>
      <div class="input-select" style="width: 336px">
        <input-select-new :is-error="form.topSection.error" v-model="form.topSection.value" @change="changeTopSection" :options="topSectionsOptions" :placeholder="'Раздел'" :list-style="{'max-height': 'none'}"></input-select-new>
      </div>
      <div class="input-select mt16" :class="{load: secondSectionsLoad }" style="width: 336px">
        <input-select-new :disabled="form.topSection.value && subSectionsOptions.length == 0" :is-error="form.subSection.error" v-model="form.subSection.value" @change="changeSubSection" @open="form.subSection.error = false" :options="subSectionsOptions" :placeholder="'Категория'" :list-style="{'max-height': 'none'}"></input-select-new>
        <svg class="select-preloader" v-if="secondSectionsLoad">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#preloader"></use>
        </svg>
      </div>
      <div class="input-select mt16" :class="{load: thirdSectionsLoad }" style="width: 336px">
        <input-select-new :disabled="form.topSection.value && deepSubSectionsOptions.length == 0" :is-error="form.deepSubSection.error" v-model="form.deepSubSection.value" @change="changeDeepSubSection" @open="form.deepSubSection.error = false" :options="deepSubSectionsOptions" :placeholder="'Подкатегория'" :list-style="{'max-height': 'none'}"></input-select-new>
        <svg class="select-preloader" v-if="thirdSectionsLoad">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#preloader"></use>
        </svg>
      </div>
      <div class="row-b mt24">
        <div class="row-b__col elem-pos-fix mr24">
          <submit-btn class="btn btn--ico" @click.native="send" :type="form.btnType">
            <span v-if="form.btnType=='normal'" class="i i-ok7 mr4"></span>Подтвердить
          </submit-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import InputStyled from '@/components/forms/InputStyled.vue';
import SubmitBtn from '@/components/forms/SubmitBtn.vue';
import InputSelectNew from '@/components/forms/InputSelectNew.vue';

export default {
  name: "RecoverRule",
  components: {
    InputStyled,
    SubmitBtn,
    InputSelectNew,
  },
  props: {
    recoverItem: {
      default: function () {
        return false
      }
    }
  },
  mounted(){
    this.form.category.text = this.section.name;
    if (this.recoverItem.sections_before && this.recoverItem.sections_before.length) {
      if (typeof (this.topSections.find(sect => sect.id === this.recoverItem.sections_before[0].id)) !== 'undefined') {
        this.form.topSection.value = this.recoverItem.sections_before[0].id;
      }
    } else {
      this.form.topSection.value = this.recoverItem.sectionTop;
    }

    this.changeTopSection();
  },
  data() {
    return {
      secondSections: {},
      secondSectionsLoad: false,
      thirdSectionsLoad: false,
      thirdSections: {},
      form:{
        topSection: {
          value: '',
          error: false,
        },
        subSection: {
          value: '',
          error: false,
        },
        deepSubSection: {
          value: '',
          error: false,
        },
        category: {
          text: '',
          error: false,
        },
        btnType: 'normal'
      },
    }
  },
  methods: {
    changeTopSection: function () {
      if (this.form.topSection.value) {
        this.getSubsections();
      }

      this.form.topSection.error = false;
    },
    changeSubSection: function () {
      this.form.subSection.error = false;
      this.form.deepSubSection.value = false;

      const selected = Object.values(this.secondSections).find(
        sec => sec.id === this.form.subSection.value
      );

      if (selected && selected.sections) {
        this.thirdSections = selected.sections;
      } else {
        this.thirdSections = [];
      }
    },
     changeDeepSubSection: function () {
      this.form.subSection.error = false;
    },
    getSubsections() {
      this.secondSectionsLoad = this.form.topSection.value.length > 0;
      this.$store.dispatch('rules/getSubsectionOption', {id: this.form.topSection.value}).then((result)=>{
        if(result.length>0){
          this.secondSections = result;
          this.secondSectionsLoad = false;
          this.$set(this.form.subSection, 'value', this.recoverItem.section);
        } else {
            this.secondSectionsLoad = false;
            this.secondSections = [];
            this.$set(this.form.subSection, 'value', []);
        }
      });
    },
    removeCat: function(){
      this.$store.dispatch('rules/removeSection', {
        id: this.section.id,
        topSection: this.activeTopSection,
      }).then(result => {
        this.$store.commit('popups/close', {name: this.popups.ruleCategory.name});
        if(result){
          if(this.activeSection == this.section.id){
            this.$router.push('/sid'+this.activeTopSection+'/sub'+this.sections[0].id+'/');
          }
        }
        else{
          this.openRemoveCatError();
        }
      });
    },
    openRemoveCatError: function () {
      this.$store.commit('popups/open', {name: this.popups.removeCatError.name});
    },
    fetchData() {
      this.highlightedId = false;
      let full = false;
      if (this.$route.hash !== "") {
        full = true;
      }

      return new Promise((resolve, reject) => {
        this.$store.dispatch('rules/getItems', {
          id: 'removed',
          reload: true,
          full: full,
        }).then(() => {
          resolve();
        });
      });
    },
    send(){
      let error = false;

      if (!this.form.topSection.value) {
          if(this.form.topSection.error ){
              this.form.topSection.error  = false;
              setTimeout(() => {
                  this.form.topSection.error  = true;
              });
          }else{
              this.form.topSection.error  = true;
          }
        error = true;
      } else {
        this.form.topSection.error = false;
      }

      if (!this.form.subSection.value && (this.form.topSection.value && this.subSectionsOptions.length == 0 || !this.form.topSection.value)) {
          if(this.form.subSection.error ){
             this.form.subSection.error  = false;
              setTimeout(() => {
                  this.form.subSection.error  = true;
              });
          }else{
              this.form.subSection.error  = true;
          }
        error = true;
      } else {
        this.form.subSection.error = false;
      }

      if (!error) {

        this.form.btnType = 'load';

        let params = {
          id: this.recoverItem.id ? this.recoverItem.id : false,
        };

        let formData = new FormData();
        formData.append('name', this.recoverItem.name);
        formData.append('text', this.recoverItem.text);
        formData.append('section', this.form.deepSubSection.value ? this.form.deepSubSection.value : this.form.subSection.value );
        formData.append('type', 'recoverRule');

        params.formData = formData;
        params.activeSection = this.form.deepSubSection.value ? this.form.deepSubSection.value : this.form.subSection.value;

        this.$store.dispatch('rules/setRule', params).then((item) => {
          this.form.btnType = 'ok';
          this.isSave = true;
          setTimeout(() => {
            this.form.btnType = 'normal';
            this.$store.commit('popups/close', {name: this.popups.addRule.name});
            this.$store.commit('popups/close', {name: this.popups.recoverRule.name});

              if(!!this.form.subSection.value){
                  let path = '/sid' + this.form.topSection.value + '/sub' + (this.form.deepSubSection.value ? this.form.deepSubSection.value : this.form.subSection.value) + '/rule' + params.id + '/';
                  this.$router.push({path});
              } else {
                  this.$router.push({path: '/'});
              }


            //На всякий случай очистим данные для редактирования раздела
            this.$store.commit('rules/setEditSection', []);
          }, 200);
        });

      }
    },
  },
  computed: {
    ...mapState({
      popups: state => state.popups.items,
      section: state => state.rules.editSection,
      sections: state => state.rules.sections,
      topSections: state => state.rules.topSections,
      sectionsLock: state => state.rules.sectionsLock,
      tumblers: state => state.rules.tumblers,
    }),
    topSectionsOptions() {
      let options = [];
        for(let i in this.sectionsLock) {
            options.push(this.sectionsLock[i]);
        }
      for(let i in this.topSections) {
        if (this.topSections[i].rights === 'W' || this.topSections[i].rights === 'C') {
          options.push(this.topSections[i]);
        }
      }

      return options;
    },
    subSectionsOptions() {
      let options = [];

      for(let i in this.secondSections) {
          options.push(this.secondSections[i]);
      }

      return options;
    },
    deepSubSectionsOptions() {
      return Array.isArray(this.thirdSections) ? this.thirdSections : [];
    },
    activeSection(){
      return this.$route.params.subid ? this.$route.params.subid : this.sections[0].id;
    },
    activeTopSection(){
      return this.recoverItem.sectionTop ? this.recoverItem.sectionTop : this.topSections[0].id;
    },
  },
}
</script>

<style scoped>

</style>
